module.exports = __webpack_public_path__ + "section/burger/img/logo.png?hash=aa20a565d00b4c9f0ece05aaa32762c4"


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/asset-loader!./LeLab.LogAlto.Web/src/modules/section/burger/img/logo.png
 ** module id = 21
 ** module chunks = 0 1
 **/